import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  page: {
    position: 'relative',
    paddingBottom: 40,
    flexDirection: 'column',
    alignItems: 'center',
  },
  topImageWrapper: {
    width: '100%',
    height: '100%',
    maxHeight: 420,
    marginBottom: 60,
  },
  topImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  centerImageWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerImage: {
    width: '100%',
    height: 'auto',
    maxWidth: 295,
    maxHeight: 65,

    objectFit: 'contain',
  },
  textContainer: {
    marginTop: 40,
    alignItems: 'center',
  },
  title: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    lineHeight: 1,
    textAlign: 'center',
    fontWeight: 900,
    marginBottom: 10,
  },
  subtitle: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1,
    textAlign: 'center',
  },

  citationWrapper: {
    textAlign: 'center',
    top: '-80px',
    height: 'auto',
    width: '100%',
    marginTop: 10,
    paddingTop: 30,
    paddingBottom: 30,
  },
  citationInnerWrapper: {
    maxWidth: 600,
    alignItems: 'center',
    paddingHorizontal: 10,
    maxHeight: 146,
  },
  citation: {
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 900,
    color: '#fff',
    textAlign: 'center',
  },
  line: {
    width: 130,
    borderTopWidth: 2,
    borderColor: '#fff',
    marginTop: 10,
    marginBottom: 10,
  },
  personDetails: {
    color: '#fff',
    fontSize: 9,
    textAlign: 'center',
  },

  threeColumnWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '90%',
    marginTop: 0,
    marginBottom: 20,
  },
  column: {
    flex: 1,
    paddingHorizontal: 10,
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 3,
  },
  leftImage: {
    width: 80,
    height: 'auto',
    objectFit: 'cover',
    marginBottom: 10,
  },
  leftText: {
    fontSize: 9,
    textAlign: 'center',
  },
  middleText: {
    fontSize: 9,
    marginBottom: 10,
    textAlign: 'center',
  },
  linkButton: {
    backgroundColor: 'black',
    borderRadius: 4,
    color: '#fff',
    fontSize: 9,
    textAlign: 'center',
    textDecoration: 'none',

    marginTop: 5,
    paddingVertical: 6,
    paddingHorizontal: 12,

    width: '100%',
  },
  coLocatedText: {
    fontFamily: 'Lato',
    fontSize: 11,
    fontWeight: 400,
    lineHeight: 1,
    textAlign: 'center',
    marginBottom: 15,
  },
  coLocatedImage: {
    width: 120,
    height: 30,
    objectFit: 'contain',
  },
});
